import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name == "ChangePassword") {
    document.title = "Change Password";
  } else {
    document.title = "My Company";
  }
  next();
});

export default router;
